import { render, staticRenderFns } from "./CreateCorporationDialog.vue?vue&type=template&id=d140b5a2"
import script from "./CreateCorporationDialog.vue?vue&type=script&lang=js"
export * from "./CreateCorporationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports